import { Tabs } from 'antd';
import CompanyData from './Data';
import CompanyLogos from './Logos';
import { ICompany } from '../../shared/interfaces';
import { useCallback, useEffect, useState } from 'react';
import { useToast } from '../../hooks/toast';
import CompanyMail from './Mail';
import { getFindCompany } from '../../http';
import { LiaBuildingSolid } from 'react-icons/lia';
import { PageIntro, PageLayout, PagePanel } from '../../components';

const Company: React.FC = () => {
  const { addToast } = useToast();
  const [company, setCompany] = useState<ICompany | null>(null);
  const [loading, setLoading] = useState<boolean>(true);

  const loadCompany = useCallback(async () => {
    await getFindCompany()
      .then((data) => {
        if (data) {
          setCompany(data);
        }
      })
      .catch(() => {
        addToast({
          type: 'error',
          title: 'Erro',
          description: `Erro ao encontrar dados da empresa`,
        });
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    loadCompany();
  }, []);

  return (
    <PageLayout>
      <PageIntro
        badge="Empresa"
        icon={<LiaBuildingSolid />}
        title="Dados da empresa"
        description="Centralize informações cadastrais, logos e configuração de e-mail da clínica em uma única área mais organizada."
      />

      <PagePanel>
        <Tabs
          type="card"
          items={[
            {
              label: `Dados da Empresa`,
              key: '1',
              children: (
                <CompanyData
                  company={company}
                  loading={loading}
                  setLoading={setLoading}
                />
              ),
            },
            {
              label: `Logos`,
              key: '2',
              children: (
                <CompanyLogos company={company} setCompany={setCompany} />
              ),
            },
            {
              label: 'Configuração de E-mail',
              key: '3',
              children: <CompanyMail />,
            },
          ]}
        />
      </PagePanel>
    </PageLayout>
  );
};

export default Company;
